import getUrlWithoutHashAndQueryString from "./getUrlWithoutHashAndQueryString";
export default url =>
  getUrlWithoutHashAndQueryString(url)
    .split("/")
    .pop();
